<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        to="/"
      >
        <img src="@/assets/login/logo.png" class="sidebar-logo" />
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img src="@/assets/login/logo.png" class="sidebar-logo" />
        <div class="sidebar-title">移动5G消息平台</div>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  width: 100%;
  min-height: 120px;
  border-bottom: rgba(255, 255, 255, 0.12) solid 1px;
  text-align: center;

  .sidebar-logo-link {
    .sidebar-logo {
      width: 80px;
      height: auto;
    }

    .sidebar-title {
      color: #fff;
      font-weight: bold;
      font-size: 18px;
    }
  }

  &.collapse {
    min-height: 50px;
    .sidebar-logo {
      width: 40px;
      height: auto;
    }
  }
}
</style>
